import { ScopedGroupContextMenu } from "./scoped-schedule-context-menu"
import { PreviewSchedule } from "./plugins/preview-schedule"
import { EditSchedule } from "./plugins/edit-schedule"
import { CompareSchedules } from "./plugins/compare-schedules"
import { ReturnToEditing } from "./plugins/return-to-editing"
import { DeleteSchedule } from "./plugins/delete-schedule"
import { DownloadDifferencesPdf } from "./plugins/download-differences-pdf"
import { DownloadSideBySidePdf } from "./plugins/download-side-by-side-pdf"
import { DownloadCustomerDifferencesPdf } from "./plugins/download-customer-differences-pdf"
import { DownloadCustomerSideBySidePdf } from "./plugins/download-customer-side-by-side-pdf"
import { ReviewCommentary } from "./plugins/review-commentary"

ScopedGroupContextMenu.plug(<PreviewSchedule />)
ScopedGroupContextMenu.plug(<EditSchedule />)
ScopedGroupContextMenu.plug(<CompareSchedules />)
ScopedGroupContextMenu.plug(<DownloadDifferencesPdf />)
ScopedGroupContextMenu.plug(<DownloadSideBySidePdf />)
ScopedGroupContextMenu.plug(<ReturnToEditing />)
ScopedGroupContextMenu.plug(<DownloadCustomerDifferencesPdf />)
ScopedGroupContextMenu.plug(<DownloadCustomerSideBySidePdf />)
ScopedGroupContextMenu.plug(<DeleteSchedule />)
ScopedGroupContextMenu.plug(<ReviewCommentary />)
